import { useEffect } from 'react';

import { usePageState } from '../../PageState/PageStateProvider';
import { useChart } from '../ChartProvider';

export const isChartLoadingFromSwitcher = (
  plotId: string | undefined,
  chartSwitcherPlotId: string | null
) => plotId !== undefined && chartSwitcherPlotId === plotId;

/** Clear chartSwitcherPlotId once this plot finishes loading after a header switcher change. */
export const useClearChartSwitcherPlotWhenDone = (isDone: boolean) => {
  const { item } = useChart();
  const { pageState, dispatch } = usePageState();

  useEffect(() => {
    if (
      isChartLoadingFromSwitcher(item.id, pageState.chartSwitcherPlotId) &&
      isDone
    ) {
      dispatch({ type: 'CLEAR_CHART_SWITCHER_PLOT' });
    }
  }, [dispatch, item.id, pageState.chartSwitcherPlotId, isDone]);
};
